import * as actionTypes from '../actionTypes';
export function longRestTextSet(longRestText) {
    return {
        type: actionTypes.LONG_REST_TEXT_SET,
        payload: longRestText,
        meta: {},
    };
}
